import Kr from './src/kr/kr';

import './src/cart/DeliveryPointMap';
const app = new Kr.App;
app.run();